import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseOutlined, EditOutlined, UserOutlined } from '@ant-design/icons';
import { fromByteArray } from 'base64-js';
import clsx from 'clsx';
import { txt } from 'libs/i18n';
import { Upload, Avatar, Tooltip, message, } from 'antd';
import IconButton from 'components/IconButton';
import styles from './style.module.less';
const MAX_AVATAR_SIZE_BYTES = 1024 * 30;
const getBadgeSizeClass = (size) => {
    if (typeof size === 'number') {
        if (size <= 24) {
            return styles.badgeSmall;
        }
        if (size >= 64) {
            return styles.badgeExtraLarge;
        }
        return styles.badgeDefault;
    }
    switch (size) {
        case 'small': {
            return styles.badgeSmall;
        }
        case 'large': {
            return styles.badgeLarge;
        }
        default: {
            return styles.badgeDefault;
        }
    }
};
const SpeakerAvatar = ({ size = 'default', value, onChange, editable = false, disabled = false, }) => {
    const previewSrc = value !== undefined && value !== '' ? `data:image/jpeg;base64,${value}` : undefined;
    const handleBeforeUpload = async (uploadedFile) => {
        if (uploadedFile.size >= MAX_AVATAR_SIZE_BYTES) {
            void message.error(txt('avatarFileSizeTooLarge'));
            return false;
        }
        const arrayBuffer = await uploadedFile.arrayBuffer();
        onChange === null || onChange === void 0 ? void 0 : onChange(fromByteArray(new Uint8Array(arrayBuffer)));
        return false;
    };
    const handleClear = (e) => {
        e.stopPropagation();
        onChange === null || onChange === void 0 ? void 0 : onChange('');
    };
    return (editable ? (_jsxs("span", { className: styles.avatarWrapper, children: [_jsxs(Upload, { accept: ".jpg,.jpeg,.png", showUploadList: false, beforeUpload: handleBeforeUpload, disabled: disabled, children: [_jsx(Avatar, { size: size, className: clsx(!disabled && styles.clickable), icon: _jsx(UserOutlined, {}), src: previewSrc }), _jsx(Tooltip, { title: txt('changePhoto'), children: _jsx("span", { className: clsx(styles.editBadge, getBadgeSizeClass(size), disabled && styles.disabled), children: _jsx(EditOutlined, {}) }) })] }), previewSrc != null && previewSrc !== '' && (_jsx(IconButton, { tooltip: txt('removePhoto'), className: clsx(styles.clearBadge, getBadgeSizeClass(size)), onClick: handleClear, disabled: disabled, children: _jsx(CloseOutlined, {}) }))] })) : (_jsx(Avatar, { size: size, icon: _jsx(UserOutlined, {}), src: previewSrc })));
};
export default SpeakerAvatar;
